export default __webpack_public_path__ + "static/media/advocate-img3.4ee919f7.png";